<script>
import HeroWorkoutMinimal from '@components/hero/hero-workout-minimal.vue';
import ListCircuitExercises from '@components/circuit/list-circuit-exercises.vue';
import CardCircuit from '@components/cards/card-circuit.vue';
import ClientWorkoutReviewBlockBlock from '@components/client/client-workout-review-block.vue';
import {
  adminPanelMethods,
  workoutComputed,
  workoutMethods,
  adminPanelComputed,
  clientProgramMethods,
  authComputed,
  clientComputed,
  clientProgramComputed,
  programComputed,
} from '@state/helpers';
import cloneDeep from 'lodash/cloneDeep';
import _isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

export default {
  components: {
    CardCircuit,
    HeroWorkoutMinimal,
    ListCircuitExercises,
    ClientWorkoutReviewBlockBlock,
  },
  props: {
    mini: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      hasChanges: false,
      footerWidth: 0,
      products: [],
      initProgramDay: {},
    };
  },
  computed: {
    ...adminPanelComputed,
    ...workoutComputed,
    ...authComputed,
    ...clientComputed,
    ...clientProgramComputed,
    ...programComputed,
    previewType() {
      return this.panelContent && this.panelContent.workoutPreviewType
        ? this.panelContent.workoutPreviewType
        : null;
    },
    circuits() {
      return this.selectedWorkout && this.selectedWorkout.circuits
        ? this.selectedWorkout.circuits
        : [];
    },
    isCompletedWorkout() {
      return (
        this.programDay &&
        this.programDay.workouts &&
        this.programDay.workouts.length > 0 &&
        this.programDay.workouts[0].clientInput &&
        this.programDay.workouts[0].clientInput.completedAt
      );
    },
    isStartedWorkout() {
      return (
        this.programDay &&
        this.programDay.workouts &&
        this.programDay.workouts.length > 0 &&
        this.programDay.workouts[0].clientInput &&
        this.programDay.workouts[0].clientInput.startedAt
      );
    },
  },
  mounted() {
    this.initProgramDay = cloneDeep(this.programDay);
    window.addEventListener('resize', this.init);
    this.init();
  },
  destroyed() {
    window.removeEventListener('resize', this.init);
  },
  methods: {
    ...adminPanelMethods,
    ...clientProgramMethods,
    ...workoutMethods,
    init() {
      if (this.$refs && this.$refs.workoutPreview) {
        this.footerWidth = this.$refs.workoutPreview.offsetWidth - 44;
      }
    },
    isEmpty(val) {
      return _isEmpty(val);
    },
  },
  watch: {
    isAdminPanelActive(val) {
      this.hasChanges = false;
      this.init();
      if (!val) {
        this.setPanelContent({ ...this.panelContent, workoutPreviewType: '' });
      }
    },
    programDay: {
      handler(newVal, oldVal) {
        if (newVal && oldVal) {
          const circuitsChanged = !isEqual(
            this.initProgramDay,
            this.programDay
          );
          this.hasChanges = circuitsChanged;
        }
      },
      deep: true,
    },
  },
};
</script>

<template>
  <div v-if="selectedWorkout" class="workout-preview" ref="workoutPreview">
    <HeroWorkoutMinimal
      :workout="selectedWorkout"
      v-if="selectedWorkout"
      :mini="mini"
    />

    <div
      :class="['workout-preview-content', { dark: previewType === 'trainer' }]"
    >
      <div v-if="isCompletedWorkout && previewType">
        <ClientWorkoutReviewBlockBlock
          :postWorkoutReview="
            programDay.workouts[0].clientInput.postWorkoutReview
          "
        />
        <div
          class="client-feed-back"
          v-if="
            programDay.workouts[0].clientInput.postWorkoutReview &&
              !isEmpty(
                programDay.workouts[0].clientInput.postWorkoutReview
                  .anyOtherFeedback
              )
          "
        >
          <h6 class="section-title">Client workout feedback </h6>
          <span>{{
            programDay.workouts[0].clientInput.postWorkoutReview
              .anyOtherFeedback
          }}</span>
        </div>
      </div>
      <template v-for="circuit in selectedWorkout.circuits">
        <ListCircuitExercises
          :key="circuit._id"
          :circuit="circuit"
          :exercises="circuit.exercises"
          v-if="!previewType"
        />
      </template>
      <div class="set-card-container">
        <span v-if="previewType && programDay.workouts[0].circuits">
          <CardCircuit
            v-for="(circuit, i) in programDay.workouts[0].circuits"
            :key="i"
            :circuit="circuit"
            :circuitIndex="i"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown
.workout-preview {
  height: 100%;
}

.set-card-container {
  height: 100%;
  padding: 1rem 0.2rem;
}

.add-to-program {
  white-space: nowrap;
}

.workout-preview-content {
  padding: 3rem;

  &.dark {
    background-color: $color-off-white;
    padding: 3rem 2.3rem;
    padding-bottom: 20rem;
  }

  .panel-footer {
    margin-left: unset;
  }

  .input-notes {
    ::v-deep .input {
      background-color: white;
    }
  }

  ::v-deep .panel-footer {
    svg {
      margin-right: 1rem;
      path {
        fill: white;
      }
    }
    .btn-primary {
      padding-left: 1.8rem;
      padding-right: 1.8rem;
    }
  }

  .client-feed-back {
    align-content: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 10%;
    margin-right: 10%;
    padding-bottom: 2rem;
    .section-title {
      font-style: normal;
      font-weight: 800;
      letter-spacing: 0.3px;
      margin-bottom: 1rem;
    }
    span {
      background: rgba($color-yellow-wo-rgb, 0.2);
      border-radius: 4px;
      font-family: $base-font-family;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      letter-spacing: 0.116667px;
      line-height: 25px;
      padding: 1.5rem;
    }
  }
}
</style>
